import TextBlock from "@shared/ui/text-block/text-block";
import "./service-info.scss";
import { FaClock, FaMoneyBill } from "react-icons/fa";
import { currencyFormat } from "@shared/utility/formats/currency-format";
import DotLabel from "@shared/ui/dot-label/dot-label";
import { GetServiceV2Dto } from "@api/api";
import { useTransactionUtil } from "@core/utility/transaction.helper";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import classNames from "classnames";

/* eslint-disable-next-line */
export interface ServiceInfoProps {
  model: GetServiceV2Dto;
  className?: string;
}

export function ServiceInfo({ model, className }: ServiceInfoProps) {
  const { formatDateTimeLocal } = useDateTimeContext();
  const { getServiceStart, getEndDateTime, convertMinutesToHours } =
    useTransactionUtil();
  const {
    service_name: name,
    amount,
    is_open_time: isOpen,
    duration,
    service_description: description,
  } = model;
  const durationHr = convertMinutesToHours(duration || 0);

  const serviceStart = formatDateTimeLocal(getServiceStart(model));
  const end = model ? getEndDateTime(model) : null;
  const endTime = end ? formatDateTimeLocal(end) : null;
  return (
    <div
      id="ServiceInfo"
      className={classNames(
        "service-info flex flex-col justify-between items-start",
        className
      )}
    >
      <div className="flex justify-between w-full">
        <h3>{name}</h3>
        <div className="flex gap-4">
          {amount && (
            <TextBlock
              icon={<FaMoneyBill />}
              label="Date"
              value={currencyFormat(amount || 0)}
            />
          )}

          {isOpen ? (
            <DotLabel label="Open Time" classBg="bg-amber-500" />
          ) : (
            <TextBlock
              icon={<FaClock />}
              label="Duration"
              value={`${durationHr}hr`}
            />
          )}
        </div>
      </div>
      <small className="block">{description}</small>
      <section className="mt-2 flex justify-between w-full">
        {serviceStart && <TextBlock label="Start" value={serviceStart} />}
        {endTime && !isOpen ? <TextBlock label="End" value={endTime} /> : null}
      </section>
    </div>
  );
}

export default ServiceInfo;
